import { getStoredAccessToken } from '../auth/access-token-store'

/**
 * SWR fetcher for the gateway data routes (/asset_1, /exposure_1, /liquidation,
 * /funding-rate-api, /pnl_history/v2, /accounts, ...).
 *
 * Every gateway route sits behind the Auth0 JWT gate (gateway `AUTH_ENABLED=true`),
 * so the AuthContext token is attached as a Bearer header. Non-2xx responses are
 * thrown so useSWR surfaces them through `error` instead of parsing an error body
 * as data.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function basicFetcher (input: RequestInfo | URL, init?: RequestInit): Promise<any> {
  const headers = new Headers(init?.headers)
  const token = getStoredAccessToken()
  if (token != null && token.length > 0 && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  const res = await fetch(input, { ...init, headers })
  if (!res.ok) {
    const target = typeof input === 'string' ? input : (input instanceof URL ? input.href : input.url)
    throw new Error(`basic-fetcher: ${res.status} ${res.statusText} (${target})`)
  }
  return await res.json()
}
